// The special meter (THPS): tricks fill it as they're scored, mid-combo
// (#184), it drains slowly between combos, and a bail empties it. The fuller it is the better the skater rides; full, it turns
// "special" and holds there a while, which is what special tricks need.

/** Combo points that fill the meter from empty. */
export const SPECIAL_FILL_POINTS = 4000;
/** Share of the meter lost per second when it isn't holding full. */
export const SPECIAL_DRAIN = 0.03;
/** Seconds a full meter stays special before it starts draining; scoring more tricks restarts it. */
export const SPECIAL_HOLD = 10;
/** Speed, pop and spin bonus at a full meter. Modest so the base tuning still feels right. */
export const SPECIAL_BOOST = 0.12;

export class SpecialMeter {
  /** 0 (empty) .. 1 (full). */
  value = 0;
  /** Seconds left holding full before it drains. */
  private hold = 0;

  /** Full: special tricks unlock, and the HUD makes it glow. */
  get special(): boolean {
    return this.value >= 1;
  }

  /** Multiplier on speed, pop and spin: 1 empty, 1 + SPECIAL_BOOST full. */
  get boost(): number {
    return 1 + SPECIAL_BOOST * this.value;
  }

  /** Points from the combo as they're scored. Filling it (or topping it up while full) restarts the hold. */
  add(points: number): void {
    if (points <= 0) return;
    this.value = Math.min(1, this.value + points / SPECIAL_FILL_POINTS);
    if (this.value >= 1) this.hold = SPECIAL_HOLD;
  }

  /** Drains, or runs down the hold; neither while a combo is going (#184). */
  update(dt: number, comboGoing = false): void {
    if (comboGoing) return;
    if (this.hold > 0) {
      this.hold = Math.max(0, this.hold - dt);
      return;
    }
    this.value = Math.max(0, this.value - SPECIAL_DRAIN * dt);
  }

  /** Full and holding (the Always special cheat, #119). */
  fill(): void {
    this.value = 1;
    this.hold = SPECIAL_HOLD;
  }

  /** A bail (or a reset) loses it all. */
  empty(): void {
    this.value = 0;
    this.hold = 0;
  }
}
